import React from 'react';
import ContributionsForm from './ContributionsForm';

const NewContributionPage = () => {
    return <ContributionsForm formType="create" />;
};

export default NewContributionPage;

